module.exports = __webpack_public_path__ + "img/HK.74d294df.jpg";